import {Button, Divider, FormControl, FormHelperText, Stack, Textarea, Typography} from "@mui/joy";
import React, {MutableRefObject, useEffect, useRef, useState} from "react";
import {useTestRoom} from "../../../../../hooks/useTestRoom";
import {Question, RawQuestion} from "../../../../../models/question";


const IeltsWritingTaskQuestionComponent = (props: {
    question: Question,
}) => {
    const testRoom = useTestRoom()
    const inputRef = useRef(null)
    const answerValue = testRoom.questionAttempts?.find(value => {
        return value.questionId === props.question.id
    })?.userAnswer

    const handleAnswerValueChange = (value: string) => {
        testRoom.answerQuestion(value, props.question, {
            questionId: props.question.id,
            contentType: "text",
            isFromGroup: false,
            questionGroupIndex: null,
            testId: props.question.testId,
            sectionName: props.question.sectionName,
        })
    }

    return <Stack paddingY={2} gap={1}>
        <FormControl>
            <Textarea
                autoFocus
                slotProps={{
                    textarea:{
                        ref:inputRef,
                    }
                }}
                placeholder={"Write here..."}
                onFocus={(e) => {
                     e.target.setSelectionRange(testRoom.cursorPositionRef.current, testRoom.cursorPositionRef.current)
                }}
                onChange={event => {
                    testRoom.cursorPositionRef.current = event.target.selectionStart
                    handleAnswerValueChange(event.target.value)
                }}
                value={answerValue}
                minRows={10}/>
        </FormControl>
        <Typography>
            Word
            count: {(answerValue as string || "").split(" ").length} / {props.question?.subSectionNumber === 1 ? "150" : "250"}
        </Typography>
    </Stack>
}

export default IeltsWritingTaskQuestionComponent